import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import ExcelImport from '@/components/excel_import.vue'
import VueElementLoading from 'vue-element-loading'

export default class extends Controller {
  static targets = ['excel']
  connect() {
    const app = createApp(ExcelImport, {
      isImportedExcel: this.element.dataset.isImportedExcel,
      department: JSON.parse(this.element.dataset.department),
      initWorkPeriod: JSON.parse(this.element.dataset.initWorkPeriod),
      creatorWorks: JSON.parse(this.element.dataset.creatorWorks) || []
    })
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.excelTarget)
  }
}
